import Image from 'components/shared/image';
import { useState } from 'react';
import styles from './beforeAfter.module.scss';

const BeforeAfter = ({
  imageBefore,
  imageAfter,
  labelBefore,
  labelAfter,
  widthDesktop,
  widthMobile,
}) => {
  const [position, setPosition] = useState(50);

  const handleSlider = event => {
    setPosition(event.target.value);
  };

  return (
    <div
      className={styles.wrapper}
      style={{ '--width-desktop': widthDesktop, '--width-mobile': widthMobile }}
    >
      <Image src={imageAfter.image} className={styles.background} />
      {labelAfter && <span className={styles.afterLabel}>{labelAfter}</span>}

      <div className={styles.limiter} style={{ width: `calc(${position}% - 0.1rem)` }}>
        <div className={styles.overlay}>
          <Image src={imageBefore.image} />
          {labelBefore && <span className={styles.beforeLabel}>{labelBefore}</span>}
        </div>
      </div>
      <div className={styles.sliderButton} style={{ left: `calc(${position}% - 2.2rem)` }} />
      <input
        type="range"
        min="1"
        max="100"
        className={styles.slider}
        name="slider"
        onChange={handleSlider}
        value={position}
      />
    </div>
  );
};

export default BeforeAfter;
